(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabCompendiumComment', LabCompendiumComment);

    LabCompendiumComment.$inject = ['$resource'];

    function LabCompendiumComment ($resource) {
        var resourceUrl =  'api/lab-compendium-comments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findByLabCompendium': {url: 'api/lab-compendium-comments/by-lab-compendium/:labCompendiumId', method: 'GET', isArray: true}
        });
    }
})();
